module.exports = __webpack_public_path__ + "img/main.db07d16d.png";